module.exports = __webpack_public_path__ + "bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/bf.svg
// module id = 443
// module chunks = 0